import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import recordApi from '../../apis/RecordApi';
import CustomContext from '../../context/CustomContext';
import { Season, Sport, User } from '../../model/Entities';
import playerCore4ScoreService from '../../services/core4/PlayerCore4Service';
import styles from './PlayerCore4ScoreComponent.module.scss';
import { Tooltip } from 'antd';
import resultApi from '../../apis/ResultApi';

/**
 * This component display the Top100 Sports Core4 score of a player.
 */
const PlayerCore4ScoreComponent: React.FC<Props> = (props) => {
    const { user, sport, season } = props;
    const context = useContext(CustomContext);
    const { auth } = context;

    /**^* METHODS */

    /*** HOOKS */

    const [score, setScore] = useState<number>();
    const [tier, setTier] = useState<number>(1);
    const [loading, setLoading] = useState<'loading'>();

    useEffect(() => {
        const init = async () => {
            try {
                if (sport && sport.id && season && user && user.id && user.profile.birthday && user.profile.gender) {
                    setLoading('loading');

                    const records = await recordApi.list(user.id, sport.id!, season.id);
                    const results = await resultApi.list(user.id, sport.id!, season.id);
                    const score = playerCore4ScoreService.getScore(
                        sport,
                        season,
                        user.profile.birthday,
                        user.profile.gender,
                        records,
                        results,
                    );
                    const tier = playerCore4ScoreService.getTier(score);

                    setScore(score);
                    setTier(tier);
                } else {
                    setScore(undefined);
                    setTier(1);
                }
            } catch (error) {
            } finally {
                setLoading(undefined);
            }
        };

        init();
    }, [auth, sport, season, user]);

    /*** COMPONENTS ***/

    return (
        <div className={styles.playerScore}>
            <div>
                <div className={styles.score}>
                    <ScoreComponent score={score} loading={loading} />
                </div>
                <TierComponent tier={tier} />
            </div>
        </div>
    );
};
export default PlayerCore4ScoreComponent;

interface Props {
    user: User | undefined;
    sport: Sport | undefined;
    season: Season | undefined;
}

const ScoreComponent: React.FC<ScoreComponentProps> = (props) => {
    const { score, loading } = props;

    if (loading === 'loading') {
        return <>&nbsp;</>;
    } else if (score !== undefined) {
        return <FormattedNumber value={score} minimumFractionDigits={0} maximumFractionDigits={0} />;
    } else {
        return <FormattedMessage id="--" />;
    }
};
interface ScoreComponentProps {
    score: number | undefined;
    loading?: 'loading';
}

const TierComponent: React.FC<TierComponentProps> = (props) => {
    const { tier } = props;

    return (
        <Tooltip title={<FormattedMessage id={`player.core4.tier.${tier}.tooltip`} />}>
            <p>
                <FormattedMessage id={`player.core4.tier.${tier}`} />
            </p>
            <img width="90" src={`${process.env.PUBLIC_URL}/img/core4/t${tier}.png`} alt="Score" />
        </Tooltip>
    );
};
interface TierComponentProps {
    tier: number | undefined;
}
